import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSTANDARDCYCLECOUNTTableStructure";
export const UPDATE_TABLE_DATA = "updateSTANDARDCYCLECOUNTTableData";
export const EXPORT_TABLE_DATA = "exportSTANDARDCYCLECOUNTTableData";
export const CREATE_CYCLE_COUNT = "createSTANDARDCYCLECOUNT";
export const CLOSE_CYCLE_COUNT = "updateSTANDARDCYCLECOUNTCloseCycleCount";
export const STORE_CYCLE_COUNT = "updateSTANDARDCYCLECOUNTStoreCount";
export const UPDATE_RECOUNT_TASK = "updateSTANDARDCYCLECOUNTRecountTask";
export const UPDATE_ASSIGN_USER = "updateSTANDARDCYCLECOUNTAssignUser";
export const UPDATE_EXPORT_TASKS = "updateSTANDARDCYCLECOUNTExportTasks";
export const UPDATE_CYCLE_COUNT_TASK_DETAILS =
  "updateSTANDARDCYCLECOUNTTaskDetails";

// mutation types
export const SET_TABLE_STRUCTURE = "setSTANDARDCYCLECOUNTTableStructure";
export const SET_TABLE_DATA = "setSTANDARDCYCLECOUNTTableData";
export const SET_TABLE_FILTER = "setSTANDARDCYCLECOUNTTableFilter";
export const SET_TABLE_PAGE = "setSTANDARDCYCLECOUNTTablePage";
export const SET_TABLE_PERPAGE = "setSTANDARDCYCLECOUNTTablePerPage";
export const SET_TABLE_SORTBY = "setSTANDARDCYCLECOUNTTableSortBy";
export const SET_TABLE_SORTORDER = "setSTANDARDCYCLECOUNTTableSortOrder";
export const SET_EXPORT_LINK = "setSTANDARDCYCLECOUNTExportLink";
export const SET_ZONES = "setSTANDARDCYCLECOUNTSetZones";
export const SET_ACTION_TYPE = "setSTANDARDCYCLECOUNTSetActionType";
export const SET_TASK_EXPORT_LINK = "setSTANDARDCYCLECOUNTTaskExportLink";
export const SET_CYCLE_COUNT_TASK_DETAILS = "setSTANDARDCYCLECOUNTTaskDetails";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  completed_count_tasks: [],
  zones: [],
  action_type: "recount",
  task_export_link: null,
  task_details: null,
};

const getters = {
  getSTANDARDCYCLECOUNTTableProperties(state) {
    return state.table_structure.properties;
  },
  getSTANDARDCYCLECOUNTTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSTANDARDCYCLECOUNTTableState(state) {
    return state.table_state;
  },
  getSTANDARDCYCLECOUNTTableHeaders(state) {
    return state.table_structure.columns;
  },
  getSTANDARDCYCLECOUNTTableFilters(state) {
    return state.table_structure.filters;
  },
  getSTANDARDCYCLECOUNTTableData(state) {
    return state.table_data.data;
  },
  getSTANDARDCYCLECOUNTExportUrl(state) {
    return state.export_link;
  },
  getSTANDARDCYCLECOUNTUsers(state) {
    return state.table_structure.users;
  },
  getSTANDARDCYCLECOUNTZones(state) {
    return state.zones;
  },
  getSTANDARDCYCLECOUNTActionType(state) {
    return state.action_type;
  },
  getSTANDARDCYCLECOUNTTaskExportUrl(state) {
    return state.task_export_link;
  },
  getSTANDARDCYCLECOUNTTaskDetails(state) {
    return state.task_details;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/standard_cycle_counts")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/standard_cycle_counts/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/standard_cycle_counts/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  async [CREATE_CYCLE_COUNT](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      const { data } = await ApiService.post(
        "/warehouse_management/standard_cycle_counts/create",
        payload
      );
      context.commit(SET_ZONES, data.zones);
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [STORE_CYCLE_COUNT](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      const res = await ApiService.post(
        "/warehouse_management/standard_cycle_counts/store",
        payload
      );
      return res;
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [UPDATE_RECOUNT_TASK](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      await ApiService.post(
        "/warehouse_management/standard_cycle_counts/recount",
        payload
      );
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [UPDATE_ASSIGN_USER](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      await ApiService.post(
        "/warehouse_management/standard_cycle_counts/assign_user",
        payload
      );
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [UPDATE_EXPORT_TASKS](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      const { data } = await ApiService.post(
        "/warehouse_management/standard_cycle_counts/export_cycle_count_tasks",
        { id: payload }
      );
      context.commit(SET_TASK_EXPORT_LINK, data.url);
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [CLOSE_CYCLE_COUNT](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      const { data } = await ApiService.post(
        "/warehouse_management/standard_cycle_counts/close",
        payload
      );
      return data;
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
  async [UPDATE_CYCLE_COUNT_TASK_DETAILS](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    try {
      const { data } = await ApiService.post(
        "/warehouse_management/standard_cycle_counts/show",
        { id: payload }
      );
      context.commit(SET_CYCLE_COUNT_TASK_DETAILS, data.standard_cycle_count);
    } finally {
      context.commit(SET_PAGE_LOADING, false);
    }
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_ZONES](state, zones) {
    state.zones = zones;
  },
  [SET_ACTION_TYPE](state, type) {
    state.action_type = type;
  },
  [SET_TASK_EXPORT_LINK](state, link) {
    state.task_export_link = link;
  },
  [SET_CYCLE_COUNT_TASK_DETAILS](state, data) {
    state.task_details = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
